import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

const TRIPS_BASE_URL = '/s-transfers/api/trips';

@Injectable({
  providedIn: 'root',
})
export class TripsService {
  constructor(private httpClient: HttpClient) {}

  public goToCheckout(items, site, language, currency, errorUrl, dealId, bookingCurrency) {
    let href = null;
    let request: TripsRequest;
    request = this.createTripRequest(items,site,language,currency, dealId, bookingCurrency);

    this.httpClient.post(request.path, request.body).subscribe(
      (resp: TripsResponse) => (href = resp.url),
      error => (href = errorUrl),
      () => (location.href = href)
    );
  }

  private createTripRequest(items, site, language, currency, dealId, bookingCurrency): TripsRequest {
    let pathParams = [];
    pathParams.push(site.toUpperCase());
    pathParams.push(language.toUpperCase());
    pathParams.push(currency.toUpperCase());
    let requestPath = TRIPS_BASE_URL + '/' + pathParams.join('/');

    return {
      path: requestPath,
      body: {
          items: items,
          dealId: dealId,
          bookingCurrency: bookingCurrency,
      },
    };
  }
}

interface TripsResponse {
  nextStep: string;
  url: string;
}

interface TripsRequest {
  path: string;
  body: Object;
}
